import * as React from 'react';
import classnames from 'classnames';

import './customizable-timeline.scss';

type Props = {
  steps: Array<JSX.Element>
}

const CustomizableTimeline = ({ steps }: Props): JSX.Element => {
  const containerClasses = classnames('customizable-timeline', {
    [`customizable-timeline--steps${steps.length}`]: true
  });

  return (
    <div className={containerClasses}>
      {steps.map((step, idx) => (
        <div
          className="customizable-timeline__step"
          key={idx}
        >
          {step}
        </div>
      ))}
    </div>
  );
};

export default CustomizableTimeline;
